/**
 * CSS-variable-safe alpha. MUI's `alpha()` decomposes the color to inject an
 * opacity channel, which throws on a `var(--mod-*)` value — design-system
 * semantic tokens are CSS variables (light/dark resolved at paint time).
 * `color-mix` applies the opacity at paint time, so it works with both CSS
 * variables and static colors. Use this instead of `alpha()` on any
 * `semanticColors.*` value.
 *
 * NOTE: `color-mix` MULTIPLIES the color's existing alpha rather than replacing
 * it (as MUI's `alpha()` did). For a token that already carries opacity — e.g.
 * `color.surface.scrim` (0.2 light / 0.5 dark) — don't wrap it here or you
 * compound the alpha (0.2 * 0.2 = 0.04); use the token directly to keep its
 * designed value. Only pass opaque tokens (`color.surface.raised`,
 * `control.bgChecked`).
 *
 * Kept dependency-free (no theme import) so consumers don't drag the MUI theme
 * — and its icon graph — into their module load.
 */
export const alphaVar = (color: string, opacity: number): string =>
  `color-mix(in srgb, ${color} ${Math.round(opacity * 100)}%, transparent)`;
